
interface VuexBindings {
  version: string;
  profile: IdTokenClaims;
  isAuthenticated: boolean;
}
import { Vue } from 'vue-property-decorator';
import { PropType, VueConstructor } from 'vue';
import BreadCrumbs from '@/navigation/BreadCrumbs.vue';
import { mapState } from 'vuex';
import { IdTokenClaims } from '../auth/idTokenClaims';
import { RootState } from '@/store/rootState';
import UserState from '@/store/user/userState';
import { ThemeManager } from '@/plugins/themeManager';

const TopNav = (Vue as VueConstructor<Vue & VuexBindings & RootState & UserState>).extend({
  props: {
    isAuthenticated: {
      type: Boolean as PropType<boolean>,
    },
    notificationBadge: {
      type: Number as PropType<number>,
      default: 0,
    },
  },
  components: {
    'bread-crumbs': Vue.extend(BreadCrumbs),
  },
  data() {
    return {
      isDarkTheme: ThemeManager.getInstance().getCurrentTheme(),
    };
  },
  created() {
    this.$root.$on('theme-changed', (isDark: boolean) => {
      this.isDarkTheme = isDark;
    });
  },
  beforeDestroy() {
    this.$root.$off('theme-changed');
  },
  computed: {
    ...mapState<RootState>({ version: 'version' }),
    ...mapState<UserState>('userStore', {
      profile: 'profile',
    }),
    avatarInitials(): string {
      if (this.profile) {
        const profile = this.profile;
        return profile.given_name.substring(0, 1) + profile.family_name.substring(0, 1);
      } else {
        return '';
      }
    },
    avatarImage(): string {
      const profile = this.profile;
      return profile?.picture;
    },
  },
  methods: {
    toggleTheme() {
      const themeManager = ThemeManager.getInstance();
      themeManager.toggleTheme();
      this.$root.$emit('theme-changed', themeManager.getCurrentTheme());
    },
  },
});
export default TopNav;
